import React, { useEffect, useState } from 'react'
import {
    Button,
    Drawer,
    Form,
    message,
    Input,
    Modal,
    Space,
    Col, Row, Popconfirm
} from 'antd';
import SearchTable from 'component/SearchTable.js';
import SearchSelect from 'component/SearchSelect';
import { post } from 'util/http';
import module from 'util/module';
const { TextArea } = Input;


const Page = ({
    param,
    setParam,
    reload
}) => {

    const [searchForm] = Form.useForm();
    const [pageForm] = Form.useForm();

    return (<Drawer title="模块版本"
        placement="right"
        width={660}
        maskClosable={false}
        onClose={() => {
            setParam({ ...param, visible: false })
        }}
        visible={param.visible}
    >

        <Modal title="添加版本" visible={param.modalVisible} onOk={() => {
            const data = pageForm.getFieldsValue();
            data.moduleCode = param.moduleCode;
            const url = data.id ? module.cloud + '/module/v1.0/version/update' : module.cloud + '/module/v1.0/version/create';
            post(url, data)
                .then(res => {
                    message.info("创建成功");
                    setParam({ ...param, modalVisible: false })
                    reload();
                })

        }} onCancel={() => { setParam({ ...param, modalVisible: false }) }}>
            <Form form={pageForm} layout="horizontal" hideRequiredMark
                labelCol={{
                    style: { width: 80 }
                }}
                initialValues={{
                    attrs: []
                }}
            >
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item style={{ display: 'none' }}
                            name="id">
                            <Input type="hidden"
                            />
                        </Form.Item>

                        <Form.Item
                            name="version"
                            label="版本号"
                            rules={[{ required: true, message: '请输入版本号' }]}
                        >
                            <Input disabled={pageForm.getFieldValue("id") != null} />
                        </Form.Item>

                    </Col>

                    <Col span={24}>
                        <Form.Item
                            name="image"
                            label="镜像地址"
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="config"
                            label="模块配置"
                        >
                            <TextArea />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>

        <Form form={searchForm} layout="inline" style={{ padding: 15 }} >
            <Form.Item
                name="searchName"
            >
                <Input
                    style={{ width: '100%' }}
                    placeholder="请输入名称"
                />
            </Form.Item>
            <Space >
                <Button onClick={() => {
                    setParam({ ...param })
                }}>搜索</Button>
                <Button type="primary" onClick={() => {
                    pageForm.resetFields();
                    setParam({ ...param, modalVisible: true })
                }}>添加新版本</Button>
            </Space>
        </Form>

        <SearchTable url={module.cloud + "/module/v1.0/version/search"}
            param={param}
            columns={[
                {
                    title: '版本',
                    dataIndex: 'version',
                    key: 'version',
                },
                {
                    title: '镜像',
                    dataIndex: 'image',
                    key: 'image',
                }, {
                    title: '操作',
                    dataIndex: 'name',
                    key: 'name',
                    render: (_, record) => (
                        <Space size="middle">

                            <a onClick={() => {
                                setParam({ ...param, modalVisible: true })
                                pageForm.setFieldsValue(record);
                            }}>修改</a>


                            <Popconfirm
                                title="你确认删除此数据么?"
                                onConfirm={() => {
                                    post(module.cloud + '/module/v1.0/version/delete',
                                        { id: record.id })
                                        .then(res => {
                                            setParam({ ...param })
                                            message.info("删除成功");
                                        })
                                }}
                                okText="确认"
                                cancelText="取消">
                                <a href="#">删除</a>
                            </Popconfirm>



                        </Space>
                    )
                }
            ]} />
    </Drawer>)
}

export default Page;